import { render, staticRenderFns } from "./AssetSummaryComponent.vue?vue&type=template&id=8fa9e08a&scoped=true&"
import script from "./AssetSummaryComponent.vue?vue&type=script&lang=js&"
export * from "./AssetSummaryComponent.vue?vue&type=script&lang=js&"
import style0 from "./AssetSummaryComponent.vue?vue&type=style&index=0&id=8fa9e08a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa9e08a",
  null
  
)

export default component.exports